import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromEmailConfiguration from './email-configuration.reducers';

export interface EmailConfigurationState {
  stateData: fromEmailConfiguration.State;
}

export interface State extends fromRoot.AppState {
  emailConfiguration: EmailConfigurationState;
}

export const reducers = {
  stateData: fromEmailConfiguration.reducer
};

export const selectEmailConfigurationState = createFeatureSelector<EmailConfigurationState>('emailConfiguration');

export const selectEmailConfigurationStateData = createSelector(selectEmailConfigurationState, (state: EmailConfigurationState) => state.stateData);

export const getEmailConfigurationState = createSelector(selectEmailConfigurationStateData, fromEmailConfiguration.getEmailConfigData);

export const getEmailConfigurationScreenError = createSelector(selectEmailConfigurationStateData, fromEmailConfiguration.getError);

export const getEmailConfigurationScreenPending = createSelector(selectEmailConfigurationStateData, fromEmailConfiguration.getPending);